import React, { useEffect } from 'react';

import { UserData } from 'shared/models/user';

import { fetchUserInfo } from '../actions';
import { useReduxDispatch, useReduxState } from '../hooks/use-redux';

interface InjectedProps {
    user: UserData;
}

interface ExposedProps {
    id: string;
}

type ReactComp<T> = React.ComponentType<T>;

export function withUser<P>(WrappedComponent: ReactComp<P & InjectedProps>): React.ComponentType<P & ExposedProps> {
    const WithUserWrapper: React.FC<P & ExposedProps> = (props) => {
        const { id, ...rest } = props;
        const users = useReduxState((state) => state.users);
        const dispatch = useReduxDispatch();

        useEffect(() => {
            if (!users.has(id)) {
                dispatch(fetchUserInfo(id));
            }
        }, [dispatch, id, users]);

        if (!users.has(id)) {
            return null;
        }

        const user = users.get(id)!;
        return <WrappedComponent {...(rest as P)} user={user} />;
    };

    WithUserWrapper.displayName = `WithUser(${WrappedComponent.displayName || WrappedComponent.name})`;

    return WithUserWrapper;
}
